<script setup lang="ts">
import { categories } from './mocks'
const { getPathWithLocale } = useLocalizedPath()
</script>

<template>
  <section class="bg-white py-7 md:py-10">
    <Container>
      <Heading tag="h2" class="mb-8">{{
        $t('widget.home_page.frequently_searched.heading')
      }}</Heading>
      <div class="grid grid-cols-1 gap-8 md:grid-cols-4">
        <div v-for="(category, index) in categories" :key="index">
          <NuxtLinkLocale
            :to="category.url"
            class="transition-colors hover:text-blue-600 hover:underline"
          >
            <Heading tag="h3" class="h6 mb-2 uppercase">{{ $t(category.title) }}</Heading>
          </NuxtLinkLocale>
          <ul class="space-y-2">
            <li v-for="(item, i) in category.items" :key="i" class="leading-4">
              <NuxtLink
                :to="getPathWithLocale(item.url)"
                class="leading-5 text-gray-500 transition-colors hover:text-blue-600 hover:underline"
              >
                {{ $t(item.label) }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </Container>
  </section>
</template>
